<div class="chat-modal" [class.show]="modalOpen">
    <ng-container *ngIf="isConversationHistory$ | async; else Conversation">
        <header class="history-header">
            <p>Discussions</p>
            <button (click)="closeModal()">
                <i class="pi pi-angle-down"></i>
            </button>
        </header>

        <div class="search-bar">
            <i class="pi pi-search"></i>
            <input type="text" placeholder="Rechercher" [(ngModel)]="searchQuery" (input)="onSearchChange()" />
        </div>

        <ng-container *ngIf="!(isLoading$ | async); else loading">
            <div class="conversations-list" *ngIf="filteredConversations && filteredConversations.length > 0; else noConversations">
                <app-conversations-list-item
                    *ngFor="let convView of filteredConversations | orderBy : 'conversation.lastMessageAt' : 'desc'"
                    [targetUser]="convView.targetUser"
                    [conversation]="convView.conversation"
                    [notifCount]="convView.conversation.unreadCount"
                    (click)="selectConversation(convView)"
                >
                </app-conversations-list-item>
            </div>

            <ng-template #noConversations>
                <div class="empty-state">
                    <p>Vous n'avez aucune conversation en cours. Commencez une nouvelle discussion !</p>
                </div>
            </ng-template>
        </ng-container>

        <ng-template #loading>
            <div class="conversations-list">
                <app-conversations-list-item *ngFor="let _ of [1, 2, 3, 4, 5]" style="pointer-events: none; cursor: default">
                </app-conversations-list-item>
            </div>
        </ng-template>
    </ng-container>

    <!-- CONVERSATION VIEW -->
    <ng-template #Conversation>
        <ng-container *ngIf="targetUser$ | async as targetUser">
            <header class="conversation-header">
                <button (click)="goBackToHistory()">
                    <i class="pi pi-arrow-left"></i>
                </button>

                <div class="user-infos">
                    <img
                        [src]="targetUser.pictureReference"
                        [alt]="targetUser.firstName + ' ' + targetUser.lastName"
                        *ngIf="targetUser.pictureReference"
                    />
                    <p>{{ targetUser.firstName }} {{ targetUser.lastName }}</p>
                </div>

                <button (click)="goBackToHistory()" disabled style="visibility: hidden">
                    <i class="pi pi-info-circle"></i>
                </button>
            </header>

            <app-conversation
                [messages]="activeMessages$ | async"
                [targetUser]="targetUser"
                [authenticatedUserId]="authenticatedUserId"
                (messageSent)="onMessageSent($event)"
            >
            </app-conversation>
        </ng-container>
    </ng-template>
</div>
